// extracted by mini-css-extract-plugin
module.exports = {"root":"ProductImage_root__1V3Jx","image":"ProductImage_image__2iPNG","loading_icon":"ProductImage_loading_icon__wd0HU"};